export Page from './page';
export FilterablePage from './filterable-page';
export ActionSection from './action-section';
export PageHeader from './page-header';
export PageContent from './page-content';
export { Tabs, Tab } from './tabs';



// WEBPACK FOOTER //
// ./app/components/page/index.js